import { render, staticRenderFns } from "./AnnouncementBar.vue?vue&type=template&id=4a0f0513&scoped=true"
import script from "./AnnouncementBar.vue?vue&type=script&lang=js"
export * from "./AnnouncementBar.vue?vue&type=script&lang=js"
import style0 from "./AnnouncementBar.vue?vue&type=style&index=0&id=4a0f0513&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.9.1_vue-template-compiler@2.7.16_webpack@5.89.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0f0513",
  null
  
)

export default component.exports